import Altynai from '../assets/img/landing/teacher/altynai.png'
import Bekzat from '../assets/img/landing/teacher/bekzat.png'
import Violetta from '../assets/img/landing/teacher/vio.png'
import Yermek from '../assets/img/landing/teacher/yermek.png'
import Beksultan from '../assets/img/landing/teacher/beks.png'
import Azamat from '../assets/img/landing/teacher/azamat.png'
import firstParent from '../assets/img/landing/review-ava/parent1.png'
import secondParent from '../assets/img/landing/review-ava/parent2.png'
import thirdParent from '../assets/img/landing/review-ava/parent3.png'
import fourthParent from '../assets/img/landing/review-ava/parent4.png'
import fifthParent from '../assets/img/landing/review-ava/parent5.png'
import sixthParent from '../assets/img/landing/review-ava/parent6.png'
import seventhParent from '../assets/img/landing/review-ava/parent7.png'
import firstStudent from '../assets/img/landing/review-ava/student1.png'
import secondStudent from '../assets/img/landing/review-ava/student2.png'
import thirdStudent from '../assets/img/landing/review-ava/student3.png'
import fourthStudent from '../assets/img/landing/review-ava/student4.png'
import fifthStudent from '../assets/img/landing/review-ava/student5.png'
import sixthStudent from '../assets/img/landing/review-ava/student6.png'
import seventhStudent from '../assets/img/landing/review-ava/student7.png'
import { sidebarLink } from '../features/types'

export const Lorum =
    'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi nunc maecenas dignissim non ultrices turpis felis. Pulvinar odio in lobortis semper tellus pharetra, aenean odio sed. Tempor, sit risus pretium pretium, eleifend enim. Amet eget sem volutpat tortor mattis ut tincidunt est. Urna volutpat semper morbi neque consectetur aliquet tellus. Egestas id etiam mi lacus in hendrerit scelerisque sed. Enim volutpat sem mattis pretium. Tristique morbi imperdiet vitae volutpat viverra in. Sed at lobortis sagittis, ullamcorper platea dictum curabitur viverra sit.'

export const BFF_SERVICE =
    'https://educon-online-bff-bzgtfgb2a7cjeqez.westeurope-01.azurewebsites.net/api'
// export const BFF_SERVICE =
//     'http://localhost:9090/api'

// Строк на страницу по умолчанию. 25 уже есть во всех rowsPerPageOptions,
// поэтому менять их не нужно.
export const DEFAULT_PAGE_SIZE = 25

export const ALPHABET = [
    { id: '1', name: 'A' },
    { id: '2', name: 'B' },
    { id: '3', name: 'C' },
    { id: '4', name: 'D' },
    { id: '5', name: 'E' },
    { id: '6', name: 'F' },
    { id: '7', name: 'G' },
    { id: '8', name: 'H' },
    { id: '9', name: 'I' },
    { id: '10', name: 'J' },
    { id: '11', name: 'K' },
    { id: '12', name: 'L' },
    { id: '13', name: 'M' },
    { id: '14', name: 'N' },
    { id: '15', name: 'O' },
    { id: '16', name: 'P' },
    { id: '17', name: 'Q' },
    { id: '18', name: 'R' },
    { id: '19', name: 'S' },
    { id: '20', name: 'T' },
    { id: '21', name: 'U' },
    { id: '22', name: 'V' },
    { id: '23', name: 'W' },
    { id: '24', name: 'X' },
    { id: '25', name: 'Y' },
    { id: '26', name: 'Z' },
]

export const LANGUAGES = ({ formatMessage }) => [
    { id: 'KZ', name: formatMessage({ id: 'kz' }) },
    { id: 'RU', name: formatMessage({ id: 'ru' }) },
]

export const COURSE_TYPES = [
    { id: "ENT", name: "ЕНТ" },
    { id: "BIL", name: "БИЛ" },
    { id: "NIS", name: "НИШ" },
]

export const VIDEO_COURSE_TYPES = [
    { id: "VIDEO_ONLY", name: "Тек видео" },
    { id: "COURSE", name: "Курс" },
]

export const VIDEO = 'VIDEO'

export const TEST = 'TEST'

export const HOMEWORK = 'HOMEWORK'

export const VIDEONOTES = 'VIDEONOTES'

export const MODERATOR = 'MODERATOR'

export const SELLER = 'SELLER'

export const CURATOR = 'CURATOR'

export const TEACHER = 'TEACHER'

export const SUPER_ADMIN = 'SUPER_ADMIN'

export const STUDENT = 'STUDENT'

export const SCHOOL_ADMIN = 'SCHOOL_ADMIN'

export const SUBJECT_HEAD = 'SUBJECT_HEAD'

export const SALES_HEAD = 'SALES_HEAD'

export const SERVICE_DIRECTOR = 'SERVICE_DIRECTOR'

export const promocodeTypes = ({ formatMessage }) => [
    {
        value: "PERCENTAGE",
        title: formatMessage({ id: "PERCENTAGE" })
    },
    {
        value: "FIXED_AMOUNT",
        title: formatMessage({ id: "FIXED_AMOUNT" })
    },
    {
        value: "FREE_SHIPPING",
        title: formatMessage({ id: "FREE_SHIPPING" })
    }
]

export const sidebarLinks = ({ formatMessage }): sidebarLink[] => [
    {
        id: 1,
        title: formatMessage({ id: 'courses' }),
        path: '/courses',
        allowedRoles: [SUPER_ADMIN, MODERATOR],
    },
    {
        id: 2,
        title: formatMessage({ id: 'subjects' }),
        path: '/subjects',
        allowedRoles: [SUPER_ADMIN, MODERATOR],
    },
    {
        id: 3,
        title: formatMessage({ id: 'exams' }),
        path: '/exams',
        allowedRoles: [SUPER_ADMIN, MODERATOR],
    },
    {
        id: 4,
        title: formatMessage({ id: 'managers' }),
        path: '/managers',
        allowedRoles: [SUPER_ADMIN],
    },
    {
        id: 5,
        title: formatMessage({ id: 'students' }),
        path: '/new-students',
        allowedRoles: [SUPER_ADMIN, MODERATOR],
    },
    // CRM «Жаңа оқушы жолы»
    {
        id: 39,
        title: formatMessage({ id: 'crmMenuIntakes' }),
        path: '/crm/intakes',
        allowedRoles: [MODERATOR, SUPER_ADMIN],
        badge: { count: 'moderatorNew', overdue: 'moderatorOverdue' },
    },
    {
        id: 47,
        title: formatMessage({ id: 'crmMenuModPayments' }),
        path: '/crm/payments',
        allowedRoles: [MODERATOR, SUPER_ADMIN],
        badge: { count: 'installmentsAlert' },
    },
    {
        id: 37,
        title: formatMessage({ id: 'crmMenuRegister' }),
        path: '/crm/register',
        allowedRoles: [SELLER],
    },
    {
        id: 38,
        title: formatMessage({ id: 'crmMenuMy' }),
        path: '/crm/my',
        allowedRoles: [SELLER],
        badge: { count: 'sellerToday' },
    },
    {
        id: 48,
        title: formatMessage({ id: 'crmMenuSellerInstallments' }),
        path: '/crm/installments',
        allowedRoles: [SELLER],
        badge: { count: 'installmentsAlert', overdue: 'installmentsAlert' },
    },
    {
        id: 6,
        title: formatMessage({ id: 'promocode' }),
        path: '/promocode',
        allowedRoles: [MODERATOR, SUPER_ADMIN, SELLER],
    },
    {
        id: 7,
        title: formatMessage({ id: 'price' }),
        path: '/price',
        allowedRoles: [MODERATOR, SUPER_ADMIN, SELLER],
    },
    {
        id: 9,
        title: formatMessage({ id: 'salesReport' }),
        path: '/sales-report',
        allowedRoles: [MODERATOR, SUPER_ADMIN],
    },
    {
        id: 10,
        title: formatMessage({ id: 'allGroups' }),
        path: '/groups',
        allowedRoles: [SUPER_ADMIN, MODERATOR],
    },
    {
        id: 11,
        title: formatMessage({ id: 'teachers' }),
        path: '/teachers',
        allowedRoles: [SUPER_ADMIN, MODERATOR],
    },
    {
        id: 12,
        title: formatMessage({ id: 'myCourses' }),
        path: '/my-courses',
        allowedRoles: [STUDENT],
    },
    {
        id: 13,
        title: formatMessage({ id: 'purchase' }),
        path: '/buy-course',
        allowedRoles: [STUDENT],
    },
    {
        id: 14,
        title: formatMessage({ id: 'timetable' }),
        path: '/timetable',
        allowedRoles: [STUDENT],
    },
    {
        id: 15,
        title: formatMessage({ id: 'myCourses' }),
        path: '/teacher-courses',
        allowedRoles: [TEACHER],
    },
    {
        id: 42,
        title: formatMessage({ id: 'crmMenuTasks' }),
        path: '/curator/crm/tasks',
        allowedRoles: [CURATOR],
        badge: { count: 'mentorOpen', overdue: 'mentorOverdue' },
    },
    {
        id: 43,
        title: formatMessage({ id: 'crmMenuMentorStudents' }),
        path: '/curator/crm/students',
        allowedRoles: [CURATOR],
    },
    {
        id: 16,
        title: formatMessage({ id: 'students' }),
        path: '/curator/students',
        allowedRoles: [CURATOR],
    },
    {
        id: 17,
        title: formatMessage({ id: 'groups' }),
        path: '/curator/groups',
        allowedRoles: [CURATOR],
    },
    {
        id: 18,
        title: formatMessage({ id: 'examAnalysis' }),
        path: '/curator/analysis',
        allowedRoles: [CURATOR],
    },
    {
        id: 22,
        title: formatMessage({ id: 'videoAnalysis' }),
        path: '/curator/video-analysis',
        allowedRoles: [CURATOR],
    },
    {
        id: 23,
        title: formatMessage({ id: 'rating' }),
        path: '/curator/rating',
        allowedRoles: [CURATOR],
    },
    {
        id: 171,
        title: formatMessage({ id: 'mrPsTitle' }),
        path: '/curator/ps-report',
        allowedRoles: [CURATOR],
    },
    {
        id: 172,
        title: formatMessage({ id: 'mrRatingTitle' }),
        path: '/curator/rating-report',
        allowedRoles: [CURATOR],
    },
    {
        id: 189,
        title: formatMessage({ id: 'surveyFillTitle' }),
        path: '/curator/surveys',
        allowedRoles: [CURATOR],
    },
    {
        id: 24,
        title: formatMessage({ id: 'salaryMySalary' }),
        path: '/curator/salary',
        allowedRoles: [CURATOR],
    },
    {
        id: 25,
        title: formatMessage({ id: 'salaryTitle' }),
        path: '/mentor-salary',
        allowedRoles: [SUPER_ADMIN, MODERATOR],
    },
    // «Оқушылар саны»: сверка CRM и платформы, числа учеников ментора по экранам
    {
        id: 186,
        title: formatMessage({ id: 'rcTitle' }),
        path: '/student-count',
        allowedRoles: [SUPER_ADMIN, MODERATOR],
    },
    {
        id: 26,
        title: formatMessage({ id: 'schools' }),
        path: '/schools',
        allowedRoles: [SUPER_ADMIN, MODERATOR],
    },
    {
        id: 27,
        title: formatMessage({ id: 'mySchool' }),
        path: '/my-school',
        allowedRoles: [SCHOOL_ADMIN],
    },
    // Пән басшы: страницы ментора по всем менторам его предметов, только чтение
    {
        id: 40,
        title: formatMessage({ id: 'crmMenuHeadNew' }),
        path: '/head/crm/new',
        allowedRoles: [SUBJECT_HEAD],
        badge: { count: 'headNew', overdue: 'headOverdue' },
    },
    {
        id: 41,
        title: formatMessage({ id: 'crmMenuHeadAll' }),
        path: '/head/crm/students',
        allowedRoles: [SUBJECT_HEAD],
    },
    {
        id: 35,
        title: formatMessage({ id: 'headOverview' }),
        path: '/head/overview',
        allowedRoles: [SUBJECT_HEAD],
    },
    {
        id: 187,
        title: formatMessage({ id: 'rcTitle' }),
        path: '/head/student-count',
        allowedRoles: [SUBJECT_HEAD],
    },
    {
        id: 28,
        title: formatMessage({ id: 'students' }),
        path: '/head/students',
        allowedRoles: [SUBJECT_HEAD],
    },
    {
        id: 29,
        title: formatMessage({ id: 'groups' }),
        path: '/head/groups',
        allowedRoles: [SUBJECT_HEAD],
    },
    {
        id: 30,
        title: formatMessage({ id: 'videoAnalysis' }),
        path: '/head/video-analysis',
        allowedRoles: [SUBJECT_HEAD],
    },
    {
        id: 36,
        title: formatMessage({ id: 'headPractice' }),
        path: '/head/practice',
        allowedRoles: [SUBJECT_HEAD],
    },
    {
        id: 173,
        title: formatMessage({ id: 'mrReportsTitle' }),
        path: '/head/reports',
        allowedRoles: [SUBJECT_HEAD],
    },
    {
        id: 31,
        title: formatMessage({ id: 'rating' }),
        path: '/head/rating',
        allowedRoles: [SUBJECT_HEAD],
    },
    {
        id: 32,
        title: formatMessage({ id: 'examAnalysis' }),
        path: '/head/analysis',
        allowedRoles: [SUBJECT_HEAD],
    },
    {
        id: 33,
        title: formatMessage({ id: 'headSalary' }),
        path: '/head/salary',
        allowedRoles: [SUBJECT_HEAD],
    },
    {
        id: 72,
        title: formatMessage({ id: 'saTitle' }),
        path: '/head/activity',
        allowedRoles: [SUBJECT_HEAD],
    },
    // Сервис басшысы: кабинет басшы по всем предметам + зарплата
    {
        id: 52,
        title: formatMessage({ id: 'headOverview' }),
        path: '/director/overview',
        allowedRoles: [SERVICE_DIRECTOR],
    },
    {
        id: 53,
        title: formatMessage({ id: 'subjects' }),
        path: '/director/subjects',
        allowedRoles: [SERVICE_DIRECTOR],
    },
    {
        id: 188,
        title: formatMessage({ id: 'rcTitle' }),
        path: '/director/student-count',
        allowedRoles: [SERVICE_DIRECTOR],
    },
    {
        id: 54,
        title: formatMessage({ id: 'students' }),
        path: '/director/students',
        allowedRoles: [SERVICE_DIRECTOR],
    },
    {
        id: 55,
        title: formatMessage({ id: 'groups' }),
        path: '/director/groups',
        allowedRoles: [SERVICE_DIRECTOR],
    },
    {
        id: 56,
        title: formatMessage({ id: 'videoAnalysis' }),
        path: '/director/video-analysis',
        allowedRoles: [SERVICE_DIRECTOR],
    },
    {
        id: 57,
        title: formatMessage({ id: 'headPractice' }),
        path: '/director/practice',
        allowedRoles: [SERVICE_DIRECTOR],
    },
    {
        id: 174,
        title: formatMessage({ id: 'mrReportsTitle' }),
        path: '/director/reports',
        allowedRoles: [SERVICE_DIRECTOR],
    },
    {
        id: 58,
        title: formatMessage({ id: 'rating' }),
        path: '/director/rating',
        allowedRoles: [SERVICE_DIRECTOR],
    },
    {
        id: 59,
        title: formatMessage({ id: 'examAnalysis' }),
        path: '/director/analysis',
        allowedRoles: [SERVICE_DIRECTOR],
    },
    {
        id: 60,
        title: formatMessage({ id: 'headSalary' }),
        path: '/director/salary',
        allowedRoles: [SERVICE_DIRECTOR],
        badge: { count: 'directorSalary', overdue: 'directorSalary' },
    },
    // «Оқушылардан опрос»
    {
        id: 90,
        title: formatMessage({ id: 'surveysTitle' }),
        path: '/surveys',
        allowedRoles: [SUPER_ADMIN, MODERATOR, SERVICE_DIRECTOR],
    },
    {
        id: 91,
        title: formatMessage({ id: 'surveyResultsTitle' }),
        path: '/survey-results',
        allowedRoles: [SUPER_ADMIN, MODERATOR, SERVICE_DIRECTOR, SUBJECT_HEAD],
    },
    {
        id: 73,
        title: formatMessage({ id: 'saTitle' }),
        path: '/director/activity',
        allowedRoles: [SERVICE_DIRECTOR],
    },
    {
        id: 44,
        title: formatMessage({ id: 'crmMenuRopReport' }),
        path: '/rop/report',
        allowedRoles: [SALES_HEAD, SUPER_ADMIN],
    },
    {
        id: 45,
        title: formatMessage({ id: 'crmMenuRopManagers' }),
        path: '/rop/managers',
        allowedRoles: [SALES_HEAD],
    },
    {
        id: 46,
        title: formatMessage({ id: 'crmMenuRopStudents' }),
        path: '/rop/students',
        allowedRoles: [SALES_HEAD],
    },
    {
        id: 49,
        title: formatMessage({ id: 'crmMenuRegister' }),
        path: '/rop/register',
        allowedRoles: [SALES_HEAD],
    },
    {
        id: 50,
        title: formatMessage({ id: 'crmMenuRopRefs' }),
        path: '/rop/refs',
        allowedRoles: [SALES_HEAD],
    },
    {
        id: 51,
        title: formatMessage({ id: 'crmMenuRopInstallments' }),
        path: '/rop/installments',
        allowedRoles: [SALES_HEAD],
        badge: { count: 'installmentsAlert' },
    },
    {
        id: 19,
        title: "Аналитика",
        path: "/analytics",
        allowedRoles: [SUPER_ADMIN, MODERATOR]
    },
    {
        id: 20,
        title: formatMessage({ id: 'schedule' }),
        path: '/schedule',
        allowedRoles: [SUPER_ADMIN, MODERATOR]
    },
    {
        id: 21,
        title: formatMessage({ id: 'sellersReport' }),
        path: '/sellers-report',
        allowedRoles: [SUPER_ADMIN, MODERATOR]
    },
]

export const fakeStudents = [
    {
        id: 1,
        firstName: 'Сержан ',
        lastName: 'Арманов',
        mobile: '+7 776 664 45 55',
        courses: ['ҰБТ'],
        subjects: ['Қазақстан тарихы', 'Оқу сауаттылығы', 'География'],
        group: 'ME-2',
        password: 'Бағлан Мырзабай',
        language: 'RU',
        sectionResult: '20:00/25:30',
        sectionPercentage: '75%',
    },
    {
        id: 2,
        firstName: 'Бағлан',
        lastName: 'Әбдіхани',
        mobile: '+7 776 664 45 55',
        courses: ['ҰБТ'],
        subjects: ['Қазақстан тарихы', 'Оқу сауаттылығы', 'География'],
        group: 'ME-2',
        password: 'Бағлан Мырзабай',
        language: 'RU',
        sectionResult: '20 из 25',
        sectionPercentage: '75%',
    },
    {
        id: 3,
        firstName: 'Саят',
        lastName: 'Райқұл',
        mobile: '+7 776 664 45 55',
        courses: ['ҰБТ,БИЛ'],
        subjects: ['ҰБТ,БИЛ'],
        group: 'FE-1',
        password: 'Бағлан Мырзабай',
        language: 'RU',
        sectionResult: '20 из 25',
        sectionPercentage: '75%',
    },
    {
        id: 4,
        firstName: 'Әділет',
        lastName: 'Мырзабай',
        mobile: '+7 776 664 45 55',
        courses: ['ҰБТ'],
        subjects: ['Қазақстан тарихы', 'Оқу сауаттылығы', 'География'],
        group: 'FE-1',
        password: 'Бағлан Мырзабай',
        language: 'RU',
        sectionResult: '20 из 25',
        sectionPercentage: '75%',
    },
    {
        id: 5,
        firstName: 'Ерасыл',
        lastName: 'Аяпберген',
        mobile: '+7 776 664 45 55',
        courses: ['ҰБТ, БИЛ'],
        subjects: ['Қазақстан тарихы', 'Оқу сауаттылығы', 'География'],
        group: 'ME-2',
        password: 'Бағлан Мырзабай',
        language: 'RU',
        sectionResult: '20 из 25',
        sectionPercentage: '75%',
    },
]

export const fakeTeachers = [
    {
        id: 1,
        name: 'Сержан ',
        firstName: 'Сержан ',
        lastName: 'Арманов',
        mobile: '+7 776 664 45 55',
        roles: ['teacher', 'coordinator'],
        courses: ['ҰБТ'],
        subjects: ['Қазақстан тарих'],
        group: 'ME-2',
        password: 'Бағлан Мырзабай',
    },
    {
        id: 2,
        name: 'Бағлан',
        firstName: 'Бағлан',
        lastName: 'Әбдіхани',
        mobile: '+7 776 664 45 55',
        roles: ['teacher', 'coordinator'],
        courses: ['ҰБТ'],
        subjects: ['Математика'],
        group: 'ME-2',
        password: 'Бағлан Мырзабай',
    },
    {
        id: 3,
        name: 'Саят',
        firstName: 'Саят',
        lastName: 'Райқұл',
        mobile: '+7 776 664 45 55',
        roles: ['teacher'],
        courses: ['ҰБТ,БИЛ'],
        subjects: ['Оқу сауаттылығы'],
        group: 'FE-1',
        password: 'Бағлан Мырзабай',
    },
    {
        id: 4,
        name: 'Әділет',
        firstName: 'Әділет',
        lastName: 'Мырзабай',
        mobile: '+7 776 664 45 55',
        roles: ['teacher'],
        courses: ['ҰБТ'],
        subjects: ['География'],
        group: 'FE-1',
        password: 'Бағлан Мырзабай',
    },
    {
        id: 5,
        name: 'Ерасыл',
        firstName: 'Ерасыл',
        lastName: 'Аяпберген',
        mobile: '+7 776 664 45 55',
        roles: ['coordinator'],
        courses: ['ҰБТ, БИЛ'],
        subjects: ['Оқу сауаттылығы'],
        group: 'ME-2',
        password: 'Бағлан Мырзабай',
    },
]

export const fakeGroups = [
    {
        id: 1,
        title: 'МФР - 1',
        language: 'ru',
        numberOfStudents: 10,
        listOfCurators: [1, 2, 3],
        courseSubjectsIds: [1, 2, 3],
        curators: ['Бағлан Мырзабай', 'Ерасыл Аяпберген'],
        subjects: ['Қазақстан тарихы', 'Оқу сауаттылығы', 'География'],
    },
    {
        id: 2,
        title: 'МФК - 2',
        language: 'kz',
        numberOfStudents: 10,
        listOfCurators: [1, 2, 3],
        courseSubjectsIds: [1, 2, 3],
        curators: ['Бағлан Мырзабай', 'Ерасыл Аяпберген'],
        subjects: ['Қазақстан тарихы', 'Оқу сауаттылығы', 'География'],
    },
    {
        id: 3,
        title: 'МФР - 3',
        language: 'ru',
        numberOfStudents: 10,
        listOfCurators: [1, 2, 3],
        courseSubjectsIds: [1, 2, 3],
        curators: ['Бағлан Мырзабай', 'Ерасыл Аяпберген'],
        subjects: ['Қазақстан тарихы', 'Оқу сауаттылығы', 'География'],
    },
]

export const fakeSubjects = [
    { id: 1, title_kz: 'Оқу сауаттылығы', title_ru: 'Оқу сауаттылығы' },
    {
        id: 2,
        title_kz: 'Математикалық сауаттылық',
        title_ru: 'Математикалық сауаттылық',
    },
    { id: 3, title_kz: 'Қазақстан тарихы', title_ru: 'Қазақстан тарихы' },
    { id: 4, title_kz: 'Физика', title_ru: 'Физика' },
    { id: 5, title_kz: 'Математика', title_ru: 'Математика' },
    { id: 6, title_kz: 'Ағылшын тілі', title_ru: 'Ағылшын тілі' },
    { id: 7, title_kz: 'Дүние жүзі тарихы', title_ru: 'Дүние жүзі тарихы' },
    { id: 8, title_kz: 'География', title_ru: 'География' },
    { id: 9, title_kz: 'Орыс тілі', title_ru: 'Орыс тілі' },
    { id: 10, title_kz: 'Химия', title_ru: 'Химия' },
    { id: 11, title_kz: 'Биология', title_ru: 'Биология' },
    { id: 12, title_kz: 'Қазақ тілі', title_ru: 'Қазақ тілі' },
]
export const fakeCourses = [
    {
        id: 1,
        title: 'ENT',
        title_kz: 'ENT',
        title_ru: 'ENT',
        promo: true,
        subjects: true,
        discount: false,
        status: 'locked',

        description:
            '12 ай ішінде ҰБТ-ға дайындалып грантқа түс. Кез келген пәнді және оның тақырыптарын таңдап ал да өзіңе ыңғайлы курс құрастыр. ',
        slogan: 'Ең мықты курс',
        price: '104 362 ₸',
        discountPercentage: '',
        discountedPrice: '104 362 ₸',
    },
    {
        id: 2,
        title: 'BIL',
        title_kz: 'BIL',
        title_ru: 'BIL',
        promo: false,
        subjects: true,
        discount: true,
        status: 'locked',

        description:
            '12 ай ішінде ҰБТ-ға дайындалып грантқа түс. Кез келген пәнді және оның тақырыптарын таңдап ал да өзіңе ыңғайлы курс құрастыр. ',
        slogan: '5 пәннен құралған пакетті ал да 30% жеңілдікке қол жеткіз',
        price: '104 362 ₸',
        discountPercentage: '-30%',
        discountedPrice: '52 181 ₸',
    },
    {
        id: 3,
        title: 'NIS',
        title_kz: 'NIS',
        title_ru: 'NIS',
        promo: true,
        subjects: true,
        discount: true,
        status: 'locked',

        description:
            '12 ай ішінде ҰБТ-ға дайындалып грантқа түс. Кез келген пәнді және оның тақырыптарын таңдап ал да өзіңе ыңғайлы курс құрастыр. ',
        slogan: '30 қыркүйекке дейін  -50%',
        price: '104 362 ₸',
        discountPercentage: '-30%',
        discountedPrice: '52 181 ₸',
    },
    {
        id: 4,
        title: 'ENT',
        title_kz: 'ENT',
        title_ru: 'ENT',
        promo: true,
        subjects: true,
        discount: false,
        status: 'unlocked',

        description:
            '12 ай ішінде ҰБТ-ға дайындалып грантқа түс. Кез келген пәнді және оның тақырыптарын таңдап ал да өзіңе ыңғайлы курс құрастыр. ',
        slogan: 'Ең мықты курс',
        price: '104 362 ₸',
        discountPercentage: '-30%',
        discountedPrice: '52 181 ₸',
    },
    {
        id: 5,
        title: 'BIL',
        title_kz: 'BIL',
        title_ru: 'BIL',
        promo: false,
        subjects: true,
        discount: true,
        status: 'unlocked',

        description:
            '12 ай ішінде ҰБТ-ға дайындалып грантқа түс. Кез келген пәнді және оның тақырыптарын таңдап ал да өзіңе ыңғайлы курс құрастыр. ',
        slogan: 'Ең мықты курс',
        price: '104 362 ₸',
        discountPercentage: '-30%',
        discountedPrice: '52 181 ₸',
    },
    {
        id: 6,
        title: 'NIS',
        title_kz: 'NIS',
        title_ru: 'NIS',
        promo: false,
        subjects: true,
        discount: false,
        status: 'locked',

        description:
            '12 ай ішінде ҰБТ-ға дайындалып грантқа түс. Кез келген пәнді және оның тақырыптарын таңдап ал да өзіңе ыңғайлы курс құрастыр. ',
        slogan: 'Ең мықты курс',
        price: '104 362 ₸',
        discountPercentage: '-30%',
        discountedPrice: '52 181 ₸',
    },
    {
        id: 7,
        title: 'ENT',
        title_kz: 'ENT',
        title_ru: 'ENT',
        promo: false,
        subjects: true,
        discount: true,
        status: 'locked',

        description:
            '12 ай ішінде ҰБТ-ға дайындалып грантқа түс. Кез келген пәнді және оның тақырыптарын таңдап ал да өзіңе ыңғайлы курс құрастыр. ',
        slogan: 'Ең мықты курс',
        price: '104 362 ₸',
        discountPercentage: '-30%',
        discountedPrice: '52 181 ₸',
    },
    {
        id: 8,
        title: 'NIS',
        title_kz: 'NIS',
        title_ru: 'NIS',
        promo: true,
        subjects: true,
        discount: true,
        status: 'locked',

        description:
            '12 ай ішінде ҰБТ-ға дайындалып грантқа түс. Кез келген пәнді және оның тақырыптарын таңдап ал да өзіңе ыңғайлы курс құрастыр. ',
        slogan: 'Ең мықты курс',
        price: '104 362 ₸',
        discountPercentage: '-30%',
        discountedPrice: '52 181 ₸',
    },
    {
        id: 9,
        title: 'NIS',
        title_kz: 'NIS',
        title_ru: 'NIS',
        promo: true,
        subjects: true,
        discount: true,
        status: 'locked',

        description:
            '12 ай ішінде ҰБТ-ға дайындалып грантқа түс. Кез келген пәнді және оның тақырыптарын таңдап ал да өзіңе ыңғайлы курс құрастыр. ',
        slogan: 'Ең мықты курс',
        price: '104 362 ₸',
        discountPercentage: '-30%',
        discountedPrice: '52 181 ₸',
    },
]

export const fakeSections = [
    { id: 1, type: 'video', title: 'Video 1', progress: 100 },
    { id: 2, type: 'test', title: 'Тақырыптық тест - 1', progress: 70 },
    { id: 3, type: 'video', title: 'Video 2', progress: 30 },
    { id: 4, type: 'test', title: 'Тақырыптық тест - 2', progress: 10 },
]

export const fakeGroupSubjects = [
    {
        id: 1,
        title_kz: 'Оқу сауаттылығы',
        title_ru: 'Оқу сауаттылығы',
        teacher: 'Бағлан Мырзабай',
        comment: 'Басталу 15:00',
        course: 'ЕНТ',
        link: 'www.zoom.kz.com.ru.ua',
    },
    {
        id: 2,
        title_kz: 'Математикалық сауаттылық',
        title_ru: 'Математикалық сауаттылық',
        teacher: 'Бағлан Мырзабай',
        comment: 'Басталу 15:00',
        course: 'ЕНТ',
        link: 'www.zoom.kz.com.ru.ua',
    },
    {
        id: 3,
        title_kz: 'Қазақстан тарихы',
        title_ru: 'Қазақстан тарихы',
        teacher: 'Бағлан Мырзабай',
        comment: 'Басталу 15:00',
        course: 'ЕНТ',
        link: 'www.zoom.kz.com.ru.ua',
    },
    {
        id: 4,
        title_kz: 'Физика',
        title_ru: 'Физика',
        teacher: 'Бағлан Мырзабай',
        comment: 'Басталу 15:00',
        course: 'ЕНТ',
        link: 'www.zoom.kz.com.ru.ua',
    },
    {
        id: 5,
        title_kz: 'Математика',
        title_ru: 'Математика',
        teacher: 'Бағлан Мырзабай',
        comment: 'Басталу 15:00',
        course: 'ЕНТ',
        link: 'www.zoom.kz.com.ru.ua',
    },
    {
        id: 6,
        title_kz: 'Ағылшын тілі',
        title_ru: 'Ағылшын тілі',
        teacher: 'Бағлан Мырзабай',
        comment: 'Басталу 15:00',
        course: 'ЕНТ',
        link: 'www.zoom.kz.com.ru.ua',
    },
    {
        id: 7,
        title_kz: 'Дүние жүзі тарихы',
        title_ru: 'Дүние жүзі тарихы',
        teacher: 'Бағлан Мырзабай',
        comment: 'Басталу 15:00',
        course: 'ЕНТ',
        link: 'www.zoom.kz.com.ru.ua',
    },
    {
        id: 8,
        title_kz: 'География',
        title_ru: 'География',
        teacher: 'Бағлан Мырзабай',
        comment: 'Басталу 15:00',
        course: 'ЕНТ',
        link: 'www.zoom.kz.com.ru.ua',
    },
    {
        id: 9,
        title_kz: 'Орыс тілі',
        title_ru: 'Орыс тілі',
        teacher: 'Бағлан Мырзабай',
        comment: 'Басталу 15:00',
        course: 'ЕНТ',
        link: 'www.zoom.kz.com.ru.ua',
    },
    {
        id: 10,
        title_kz: 'Химия',
        title_ru: 'Химия',
        teacher: 'Бағлан Мырзабай',
        comment: 'Басталу 15:00',
        course: 'ЕНТ',
        link: 'www.zoom.kz.com.ru.ua',
    },
    {
        id: 11,
        title_kz: 'Биология',
        title_ru: 'Биология',
        teacher: 'Бағлан Мырзабай',
        comment: 'Басталу 15:00',
        course: 'ЕНТ',
        link: 'www.zoom.kz.com.ru.ua',
    },
    {
        id: 12,
        title_kz: 'Қазақ тілі',
        title_ru: 'Қазақ тілі',
        teacher: 'Бағлан Мырзабай',
        comment: 'Басталу 15:00',
        course: 'ЕНТ',
        link: 'www.zoom.kz.com.ru.ua',
    },
]

export const fakeQuestions = [
    {
        id: 1,
        title: 'Это понятие , вводимое в механике для обозначения тела, которое рассматривается как точка, имеющая массу.',
        options: [
            {
                id: 1,
                name: 'Закон Ньютона',
                isCorrect: true,
                selected: true,
            },
            {
                id: 2,
                name: 'Геоцентрически система мира',
                isCorrect: false,
                selected: false,
            },
            {
                id: 3,
                name: 'Свободное падение тел',
                isCorrect: false,
                selected: false,
            },
            {
                id: 4,
                name: 'Закон Гравитации',
                isCorrect: false,
                selected: false,
            },
        ],
    },
    {
        id: 2,
        title: 'Это понятие , вводимое в механике для обозначения тела, которое рассматривается как точка, имеющая массу.',
        options: [
            {
                id: 1,
                name: 'Закон Ньютона',
                isCorrect: true,
                selected: false,
            },
            {
                id: 2,
                name: 'Геоцентрически система мира',
                isCorrect: false,
                selected: false,
            },
            {
                id: 3,
                name: 'Свободное падение тел',
                isCorrect: false,
                selected: true,
            },
            {
                id: 4,
                name: 'Закон Гравитации',
                isCorrect: false,
                selected: false,
            },
        ],
    },
    {
        id: 3,
        title: 'Это понятие , вводимое в механике для обозначения тела, которое рассматривается как точка, имеющая массу.',
        options: [
            { id: 1, name: 'Закон Ньютона', isCorrect: false, selected: false },
            {
                id: 2,
                name: 'Геоцентрически система мира',
                isCorrect: false,
                selected: false,
            },
            {
                id: 3,
                name: 'Свободное падение тел',
                isCorrect: false,
                selected: false,
            },
            {
                id: 4,
                name: 'Закон Гравитации',
                isCorrect: true,
                selected: true,
            },
        ],
    },
    {
        id: 4,
        title: 'Это понятие , вводимое в механике для обозначения тела, которое рассматривается как точка, имеющая массу.',
        options: [
            { id: 1, name: 'Закон Ньютона', isCorrect: false, selected: true },
            {
                id: 2,
                name: 'Геоцентрически система мира',
                isCorrect: false,
                selected: false,
            },
            {
                id: 3,
                name: 'Свободное падение тел',
                isCorrect: true,
                selected: false,
            },
            {
                id: 4,
                name: 'Закон Гравитации',
                isCorrect: false,
                selected: false,
            },
        ],
    },
]

// const language = useAppSelector(lang)

export const TeacherInfo = (formatMessage, locale) => [
    {
        id: 1,
        name: 'Алтынай Тауыпалдиева',
        buttonText: formatMessage({ id: 'historyOfKazakhstan' }),
        info: `
            <ul style='line-height: 40px'>
                <li>${formatMessage({ id: 'altynaiText1' })}</li>
                <li>${formatMessage({ id: 'altynaiText2' })}</li>
                <li>${formatMessage({ id: 'altynaiText3' })}</li>
                <li>${formatMessage({ id: 'altynaiText4' })}</li>
                <li>${formatMessage({ id: 'altynaiText5' })}</li>
                <li>${formatMessage({ id: 'altynaiText6' })}</li>
            </ul>
        `,
        img: Altynai,
    },
    {
        id: 2,
        name: 'Бекзат Конусов',
        buttonText: formatMessage({ id: 'physics' }),
        info: `
            <ul style='line-height: 40px'>
                <li>${formatMessage({ id: 'bekzatText1' })}</li>
                <li>${formatMessage({ id: 'bekzatText2' })}</li>
                <li>${formatMessage({ id: 'bekzatText3' })}</li>
                <li>${formatMessage({ id: 'bekzatText4' })}</li>
                <li>${formatMessage({ id: 'bekzatText5' })}</li>
            </ul>
        `,
        img: Bekzat,
    },
    {
        id: 3,
        name: 'Виолетта Ли',
        buttonText: formatMessage({ id: 'readingLiteracy' }),
        info: `
            <ul style='line-height: 40px'>
                <li>${formatMessage({ id: 'violetta1' })}</li>
                <li>${formatMessage({ id: 'violetta2' })}</li>
                <li>${formatMessage({ id: 'violetta3' })}</li>
                <li>${formatMessage({ id: 'violetta4' })}</li>
                <li>${formatMessage({ id: 'violetta5' })}</li>
                <li>${formatMessage({ id: 'violetta6' })}</li>
            </ul>
        `,
        img: Violetta,
    },
    {
        id: 4,
        name: 'Ермек Жантасов',
        buttonText: 'География',
        info: `
            <ul style='line-height: 40px'>
                <li>${formatMessage({ id: 'yermek1' })}</li>
                <li>${formatMessage({ id: 'yermek2' })}</li>
                <li>${formatMessage({ id: 'yermek3' })}</li>
                <li>${formatMessage({ id: 'yermek4' })}</li>
                <li>${formatMessage({ id: 'yermek5' })}</li>
                <li>${formatMessage({ id: 'yermek6' })}</li>
            </ul>
        `,
        img: Yermek,
    },
    {
        id: 5,
        name: 'Бексұлтан Жалғас',
        buttonText: 'Информатика',
        info: `
            <ul style='line-height: 40px'>
                <li>${formatMessage({ id: 'beksultan1' })}</li>
                <li>${formatMessage({ id: 'beksultan2' })}</li>
                <li>${formatMessage({ id: 'beksultan3' })}</li>
                <li>${formatMessage({ id: 'beksultan4' })}</li>
                <li>${formatMessage({ id: 'beksultan5' })}</li>
                <li>${formatMessage({ id: 'beksultan6' })}</li>
                <li>${formatMessage({ id: 'beksultan7' })}</li>
            </ul>
        `,
        img: Beksultan,
    },
    {
        id: 6,
        name: 'Азамат Шумбалов',
        buttonText: formatMessage({ id: 'englishLanguage' }),
        info: `
            <ul style='line-height: 40px'>
                <li>${formatMessage({ id: 'azamat1' })}</li>
                <li>${formatMessage({ id: 'azamat2' })}</li>
                <li>${formatMessage({ id: 'azamat3' })}</li>
                <li>${formatMessage({ id: 'azamat4' })}</li>
                <li>${formatMessage({ id: 'azamat5' })}</li>
                <li>${formatMessage({ id: 'azamat6' })}</li>
                <li>${formatMessage({ id: 'azamat7' })}</li>
                <li>${formatMessage({ id: 'azamat8' })}</li>
                <li>${formatMessage({ id: 'azamat9' })}</li>
                <li>${formatMessage({ id: 'azamat10' })}</li>
                <li>${formatMessage({ id: 'azamat11' })}</li>
                <li>${locale === 'ru' ? formatMessage({ id: 'azamat12' }) : ''}</li>
            </ul>
        `,
        img: Azamat,
    },
]

export const ParentContent = [
    {
        id: 1,
        name: 'Гульвира Армановна',
        img: firstParent,
        text: 'Қызықты және сапалы дайындық үшін EduconOnline онлайн курсына көп рахмет! Ең бастысы, емтиханға дайындық жоспарын құруға уақыт жұмсаудың қажеті жоқ. Жоспар беріледі, оны сапалы орындау қалады. Егер бос уақыт қалса, қосымша мақалалар, тереңірек зерттеу үшін тақырыптар әрқашан ұсынылады. Сценарий форматы материалдарды дайындауға, қайталауға және есте сақтауға көп көмектеседі. Марк пен Даниелдің әзілдері мен оңай қол жетімді тәсілі күрделі тақырыптарды көрмеуге мүмкіндік береді, өйткені олар түсіндірілгеннен кейін бәрі түсінікті болады. Егер Мен әлі де бірдеңе түсінбеген болсам, онда сіз бәрін егжей-тегжейлі түсіндіретін тәлімгерден сұрай аласыз. Сабақтың әртүрлі форматтары дайындыққа деген қызығушылықтың төмендеуіне жол бермеді. Мен әрқашан дайындыққа қуанышпен уақыт бөлдім.',
    },
    {
        id: 2,
        name: 'Светлана Балаева',
        img: secondParent,
        text: 'Мұнда жаттығу туралы шешім ең жақсылардың бірі болды!!! Емтихан үшін барлық қажетті ақпаратты алатыныңызға сенімді болыңыз, үй тапсырмасының көп мөлшерімен хош иістендірілген, бәрін сіздің басыңызға дәл бекіту үшін Али Ира өте қарапайым, түсінікті және одан өте қызықты, содан кейін Сіз бұл туралы көбірек біле аласыз. тәжірибеде Филден (ешқашан тәжірибені жіберіп алмаңыз, бұл өте маңызды және керемет оқытудың бір бөлігі).',
    },
    {
        id: 3,
        name: 'Дүйсен Армановна',
        img: thirdParent,
        text: 'Қызықты және сапалы дайындық үшін EduconOnline онлайн курсына көп рахмет! Ең бастысы, емтиханға дайындық жоспарын құруға уақыт жұмсаудың қажеті жоқ. Жоспар беріледі, оны сапалы орындау қалады. Егер бос уақыт қалса, қосымша мақалалар, тереңірек зерттеу үшін тақырыптар әрқашан ұсынылады. Сценарий форматы материалдарды дайындауға, қайталауға және есте сақтауға көп көмектеседі. Марк пен Даниелдің әзілдері мен оңай қол жетімді тәсілі күрделі тақырыптарды көрмеуге мүмкіндік береді, өйткені олар түсіндірілгеннен кейін бәрі түсінікті болады. Егер Мен әлі де бірдеңе түсінбеген болсам, онда сіз бәрін егжей-тегжейлі түсіндіретін тәлімгерден сұрай аласыз. Сабақтың әртүрлі форматтары дайындыққа деген қызығушылықтың төмендеуіне жол бермеді. Мен әрқашан дайындыққа қуанышпен уақыт бөлдім.',
    },
    {
        id: 4,
        name: 'Сәндікүл Армановна',
        img: fourthParent,
        text: 'Қызықты және сапалы дайындық үшін EduconOnline онлайн курсына көп рахмет! Ең бастысы, емтиханға дайындық жоспарын құруға уақыт жұмсаудың қажеті жоқ. Жоспар беріледі, оны сапалы орындау қалады. Егер бос уақыт қалса, қосымша мақалалар, тереңірек зерттеу үшін тақырыптар әрқашан ұсынылады. Сценарий форматы материалдарды дайындауға, қайталауға және есте сақтауға көп көмектеседі. Марк пен Даниелдің әзілдері мен оңай қол жетімді тәсілі күрделі тақырыптарды көрмеуге мүмкіндік береді, өйткені олар түсіндірілгеннен кейін бәрі түсінікті болады. Егер Мен әлі де бірдеңе түсінбеген болсам, онда сіз бәрін егжей-тегжейлі түсіндіретін тәлімгерден сұрай аласыз. Сабақтың әртүрлі форматтары дайындыққа деген қызығушылықтың төмендеуіне жол бермеді. Мен әрқашан дайындыққа қуанышпен уақыт бөлдім.',
    },
    {
        id: 5,
        name: 'Мағрипа Армановна',
        img: fifthParent,
        text: 'Қызықты және сапалы дайындық үшін EduconOnline онлайн курсына көп рахмет! Ең бастысы, емтиханға дайындық жоспарын құруға уақыт жұмсаудың қажеті жоқ. Жоспар беріледі, оны сапалы орындау қалады. Егер бос уақыт қалса, қосымша мақалалар, тереңірек зерттеу үшін тақырыптар әрқашан ұсынылады. Сценарий форматы материалдарды дайындауға, қайталауға және есте сақтауға көп көмектеседі. Марк пен Даниелдің әзілдері мен оңай қол жетімді тәсілі күрделі тақырыптарды көрмеуге мүмкіндік береді, өйткені олар түсіндірілгеннен кейін бәрі түсінікті болады. Егер Мен әлі де бірдеңе түсінбеген болсам, онда сіз бәрін егжей-тегжейлі түсіндіретін тәлімгерден сұрай аласыз. Сабақтың әртүрлі форматтары дайындыққа деген қызығушылықтың төмендеуіне жол бермеді. Мен әрқашан дайындыққа қуанышпен уақыт бөлдім.',
    },
    {
        id: 6,
        name: 'Мұрат Ермеков',
        img: sixthParent,
        text: 'Қызықты және сапалы дайындық үшін EduconOnline онлайн курсына көп рахмет! Ең бастысы, емтиханға дайындық жоспарын құруға уақыт жұмсаудың қажеті жоқ. Жоспар беріледі, оны сапалы орындау қалады. Егер бос уақыт қалса, қосымша мақалалар, тереңірек зерттеу үшін тақырыптар әрқашан ұсынылады. Сценарий форматы материалдарды дайындауға, қайталауға және есте сақтауға көп көмектеседі. Марк пен Даниелдің әзілдері мен оңай қол жетімді тәсілі күрделі тақырыптарды көрмеуге мүмкіндік береді, өйткені олар түсіндірілгеннен кейін бәрі түсінікті болады. Егер Мен әлі де бірдеңе түсінбеген болсам, онда сіз бәрін егжей-тегжейлі түсіндіретін тәлімгерден сұрай аласыз. Сабақтың әртүрлі форматтары дайындыққа деген қызығушылықтың төмендеуіне жол бермеді. Мен әрқашан дайындыққа қуанышпен уақыт бөлдім.',
    },
    {
        id: 7,
        name: 'Қанат Нұрлан',
        img: seventhParent,
        text: 'Қызықты және сапалы дайындық үшін EduconOnline онлайн курсына көп рахмет! Ең бастысы, емтиханға дайындық жоспарын құруға уақыт жұмсаудың қажеті жоқ. Жоспар беріледі, оны сапалы орындау қалады. Егер бос уақыт қалса, қосымша мақалалар, тереңірек зерттеу үшін тақырыптар әрқашан ұсынылады. Сценарий форматы материалдарды дайындауға, қайталауға және есте сақтауға көп көмектеседі. Марк пен Даниелдің әзілдері мен оңай қол жетімді тәсілі күрделі тақырыптарды көрмеуге мүмкіндік береді, өйткені олар түсіндірілгеннен кейін бәрі түсінікті болады. Егер Мен әлі де бірдеңе түсінбеген болсам, онда сіз бәрін егжей-тегжейлі түсіндіретін тәлімгерден сұрай аласыз. Сабақтың әртүрлі форматтары дайындыққа деген қызығушылықтың төмендеуіне жол бермеді. Мен әрқашан дайындыққа қуанышпен уақыт бөлдім.',
    },
]

export const StudentContent = (formatMessage) => [
    {
        id: 1,
        name: 'Асель',
        ball: formatMessage({ id: 'entScoreHolder' }, { score: '111' }),
        img: firstStudent,
        text: formatMessage({ id: 'firstOpinion' }),
    },
    {
        id: 2,
        name: 'Арман',
        ball: formatMessage({ id: 'entScoreHolder' }, { score: '124' }),
        img: secondStudent,
        text: formatMessage({ id: 'secondOpinion' }),
    },
    {
        id: 3,
        name: 'Жандос',
        ball: formatMessage({ id: 'entScoreHolder' }, { score: '120' }),
        img: thirdStudent,
        text: formatMessage({ id: 'thirdOpinion' }),
    },
    {
        id: 4,
        name: 'Сабина',
        img: fourthStudent,
        text: formatMessage({ id: 'fourthOpinion' }),
    },
    {
        id: 6,
        name: 'Жалғас',
        img: sixthStudent,
        text: formatMessage({ id: 'sixthOpinion' }),
    },
    {
        id: 7,
        name: 'Салтанат',
        ball: formatMessage({ id: 'entScoreHolder' }, { score: '122' }),
        img: seventhStudent,
        text: formatMessage({ id: 'seventhOpinion' }),
    },
    {
        id: 5,
        name: 'Жалғас',
        ball: formatMessage({ id: 'entScoreHolder' }, { score: '115' }),
        img: seventhStudent,
        text: formatMessage({ id: 'eightsOpinion' }),
    },
]

export const FeaturesDescription = (formatMessage) => [
    {
        id: 1,
        title: formatMessage({ id: 'videoLessons' }),
        videolink: 'https://youtu.be/2VgwEp9Q7Ew',
        desription: 'videoLessonFeatureText',
    },
    {
        id: 2,
        title: formatMessage({ id: 'topicTests' }),
        videolink: 'https://youtu.be/6gpkU1cVTko',
        desription: 'topicTestsFeatureText',
    },
    {
        id: 3,
        title: formatMessage({ id: 'workOnMistake' }),
        videolink: 'https://youtu.be/y1hsnH6zIiE',
        desription: 'workOnMistakeFeatureText',
    },
]

export const PricelistCourseCards = [
    {
        title: 'ҰБТ курсы',
        price: '54 000тг',
        label: 'Ең мықты курс',
        description:
            '12 ай ішінде ҰБТ-ға дайындалып грантқа түс. Кез келген пәнді және оның тақырыптарынтаңдап ал да өзіңе ыңғайлы курс құрастыр.',
        listItems: [
            'видео сабақтар',
            'тақырыптық тесттер',
            'қатемен жұмыс',
            '12 ай',
            'сұрақтардың видео шешімі',
            'прогресс анализі',
        ],
    },
    {
        title: 'БИЛ курсы',
        price: '50 000тг',
        label: '50% жеңілдік',
        startDate: '30 қыркүйекке дейін',
        description:
            '12 ай ішінде ҰБТ-ға дайындалып грантқа түс. Кез келген пәнді және оның тақырыптарынтаңдап ал да өзіңе ыңғайлы курс құрастыр.',
        listItems: [
            'видео сабақтар',
            'тақырыптық тесттер',
            'қатемен жұмыс',
            '12 ай',
            'сұрақтардың видео шешімі',
            'прогресс анализі',
        ],
    },
]
